<app-nav-header></app-nav-header>
<app-sidebar-menu></app-sidebar-menu>
<ngx-loading [show]="loading"> </ngx-loading>
<div class="page-content-wrapper">
  <div class="page-content">
    <div class="page-bar">
      <div class="page-title-breadcrumb">
        <div class="container">
          <div class="card card-topline-green">
            <div class="card-head">
              <header>Visualizar Parâmetro Financeiro</header>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-12">
                      <b>Tipo</b>
                    </div>
                    <div class="col-md-12">
                      {{ financialParameter.type }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-12">
                      <b>Parâmetro</b>
                    </div>
                    <div class="col-md-12">
                      {{ financialParameter.parameter }}
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-12">
                      <b>Valor</b>
                    </div>
                    <div class="col-md-12">
                      {{ financialParameter.value }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-12">
                      <b>Status</b>
                    </div>
                    <div class="col-md-12">
                      <span
                        *ngIf="financialParameter.active"
                        class="label label-sucess label-mini"
                        >Ativo</span
                      >
                      <span
                        *ngIf="!financialParameter.active"
                        class="label label-danger label-mini"
                        >Inativo</span
                      >
                    </div>
                    <div class="col-md-6"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <div class="row">
                <div class="col-md-4">
                  <a
                    routerLink="/parameters/financial-parameter/edit/{{ financialParameter.id }}"
                    class="btn btn-warning"
                    >Editar</a
                  >
                </div>
                <div class="col-md-4">
                  <a routerLink="/parameters/financial-parameter" class="btn btn-info">Voltar</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
